import { gql } from "graphql-request";

import { client } from "@krea/customer-features/graphql";

const TRACK_LOAN_APPLICATION_DRAFT_MUTATION = gql`
  mutation TrackLoanApplicationDraftMutation($id: ID!) {
    trackLoanApplicationDraft(id: $id) {
      tracking {
        currency
        conversionValue
      }
    }
  }
`;

const TRACK_LOAN_APPLICATION_RATE_FORECAST_EXECUTED_MUTATION = gql`
  mutation TrackLoanApplicationRateForecastExecutedMutation($id: ID!) {
    trackLoanApplicationRateForecastExecuted(id: $id) {
      tracking {
        currency
        conversionValue
      }
    }
  }
`;

export interface ITrackLoanApplicationInput {
  loanApplicationID: string;
}

export interface ITrackLoanApplicationDraftResponse {
  trackLoanApplicationDraft: {
    tracking: {
      currency: string;
      conversionValue: number | null;
    };
  };
}

export const trackLoanApplicationDraftConversion = async ({
  loanApplicationID,
}: ITrackLoanApplicationInput) => {
  return client.request<ITrackLoanApplicationDraftResponse, { id: string }>(
    TRACK_LOAN_APPLICATION_DRAFT_MUTATION,
    {
      id: loanApplicationID,
    },
  );
};

export interface ITrackLoanApplicationRateForecastExecutedResponse {
  trackLoanApplicationRateForecastExecuted: {
    tracking: {
      currency: string;
      conversionValue: number | null;
    };
  };
}

export const trackLoanApplicationRateForecastExecuted = async ({
  loanApplicationID,
}: ITrackLoanApplicationInput) => {
  return client.request<
    ITrackLoanApplicationRateForecastExecutedResponse,
    { id: string }
  >(TRACK_LOAN_APPLICATION_RATE_FORECAST_EXECUTED_MUTATION, {
    id: loanApplicationID,
  });
};
